// 移植自 lib/auth/account.js（原本靠 Solid signal）。window.user 由後端在 index.html 注入，
// 頁面存活期間不會變，登出一律整頁重載，所以這裡用普通物件即可，不需要 React 狀態。

function detectEnv() {
  const host = location.hostname
  if (host.startsWith('stg.')) return 'Stg.'
  if (host.startsWith('dev.') || host === 'localhost') return 'Dev'
  return ''
}

const raw = window.user ?? {}
if (!raw.env) raw.env = detectEnv()

export const account = raw

export function logout() {
  // 同舊版 setAccount({})：先清掉登入狀態，同時回來的其他 401 看到未登入就不再重複登出／重載（request.js）
  delete account.username
  return fetch('/api/v1/logout').finally(() => {
    document.location.reload()
  })
}

export function keepalive() {
  if (!account.username) return
  return fetch('/api/v1/keepalive').catch(() => {}).finally(() => {
    setTimeout(keepalive, 3_600_000)
  })
}

// PSD-344 權限鍵改名的新舊雙向別名，與 lib/auth/account.js 同一份表；全部改名完成後兩邊一起移除。
const PERM_RENAMES = {
  'view lines': 'view line list',
  'view merchants': 'view merchant list',
  'view campaigns': 'view campaign list',
  'view products': 'view product list',
  'view providers': 'view product providers',
  'view line remark': 'view line remarks',
  'view merchant financial groupings': 'view merchant financial grouping',
  'setup merchant pricing': 'set up merchant pricing',
  'handover line am staff': 'hand over line to am',
  'manage public tag': 'manage public tags',
  'manage private tag': 'manage private tags',
  'add provider': 'add product provider',
  'edit provider': 'edit product provider',
  'delete provider': 'delete product provider',
  'edit task': 'edit and copy task',
  'view oplogs': 'view operation log',
  'view staff roles': 'view roles',
  'add staff role': 'add role',
  'edit staff role': 'edit role',
  'view staff users': 'view staff list',
  'add staff user': 'add staff',
  'edit staff user': 'edit staff',
}
const PERM_ALIASES = { ...PERM_RENAMES }
for (const [oldName, newName] of Object.entries(PERM_RENAMES)) PERM_ALIASES[newName] = oldName

export function isAdmin() {
  return account.roles?.includes('admin') ?? false
}

export function access(...actions) {
  if (isAdmin()) return true
  const permissions = account.permissions ?? []
  return actions.some((action) => {
    if (permissions.includes(action)) return true
    const alias = PERM_ALIASES[action]
    return Boolean(alias) && permissions.includes(alias)
  })
}
